// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share_box__bR-W5 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  cursor: pointer;
}
.share_btn__Hp7U2 {
  border: 1px solid #999;
  /* width: 100%; */
  padding: 10px;
  border-radius: 10px;
}
.share_input__ZhhkN {
  display: flex;
  justify-content: center;
  align-items: center;
}
.share_input__ZhhkN input {
  border: 1px solid #999;
  padding: 0.5rem;
  border-radius: 10px;
  font-size: 14px;
  width: 100%;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/shareButton/share.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":[".box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 14px;\n  width: 100%;\n  cursor: pointer;\n}\n.btn {\n  border: 1px solid #999;\n  /* width: 100%; */\n  padding: 10px;\n  border-radius: 10px;\n}\n.input {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.input input {\n  border: 1px solid #999;\n  padding: 0.5rem;\n  border-radius: 10px;\n  font-size: 14px;\n  width: 100%;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `share_box__bR-W5`,
	"btn": `share_btn__Hp7U2`,
	"input": `share_input__ZhhkN`
};
export default ___CSS_LOADER_EXPORT___;
